module.exports = "/assets/dist/img/select-patch-icon.svg?9b2d91cc7186c82043664b5a1dc2f00c";


//////////////////
// WEBPACK FOOTER
// ./WebResources/vue/letter-jackets/catalog-details/components/SleevePatchSelection/assets/select-patch-icon.svg
// module id = 1405
// module chunks = 0